module.exports = __webpack_public_path__ + "static/media/monthly_discussion_v2.be6e20eb.jpg";